import { FileText } from 'lucide-react';
import type { FC } from 'react';

interface TranscriptionPanelProps {
  transcript: string | null | undefined;
}

const TranscriptionPanel: FC<TranscriptionPanelProps> = ({ transcript }) => {
  if (!transcript) {
    return (
      <div className="fc-card p-5">
        <div className="flex items-center gap-2 text-slate-400 dark:text-slate-500">
          <FileText className="h-4 w-4" />
          <span className="text-xs font-medium uppercase tracking-wider">Transcription</span>
        </div>
        <p className="mt-3 text-sm italic text-slate-400 dark:text-slate-500">
          Aucune transcription disponible.
        </p>
      </div>
    );
  }

  return (
    <div className="fc-card p-5">
      <div className="flex items-center gap-2 text-slate-500 dark:text-slate-400">
        <FileText className="h-4 w-4" />
        <span className="text-xs font-medium uppercase tracking-wider">Transcription</span>
      </div>
      <div className="mt-3 max-h-48 overflow-y-auto">
        <p className="whitespace-pre-wrap text-sm leading-relaxed text-slate-700 dark:text-slate-300">
          {transcript}
        </p>
      </div>
    </div>
  );
};

export default TranscriptionPanel;
